<ez-section>
  <ez-block>
    <div class="phms-intake-staging">
      <div class="page-header">
        <div>
          <h2>{{ pageTitle }}</h2>
          <p class="page-subtitle">{{ pageSubtitle }}</p>
        </div>
      </div>

      <p class="loading-text" *ngIf="!canSubmit()" role="status" aria-live="polite">
        You do not have permission to submit intake submissions. Frontend gating is a UX hint - server authorization is authoritative.
      </p>

      <ng-container *ngIf="canSubmit()">
        <div class="message-box success" *ngIf="successMessage()" role="status" aria-live="polite">
          {{ successMessage() }}
        </div>

        <div class="message-box error" *ngIf="errorState() as error" role="alert" aria-live="assertive">
          <p>{{ error.title }}</p>
          <ul>
            <li *ngFor="let message of error.messages">{{ message }}</li>
          </ul>
          <div class="error-meta" *ngIf="error.problemCode || error.issueCodes.length > 0 || error.correlationId">
            <span *ngIf="error.problemCode">Problem code: {{ error.problemCode }}</span>
            <span *ngIf="error.issueCodes.length > 0">Issue codes: {{ error.issueCodes.join(', ') }}</span>
            <span *ngIf="error.correlationId">Correlation ID: {{ error.correlationId }}</span>
          </div>
        </div>

        <p class="loading-text" *ngIf="!programScopeKeysLoaded()" role="status" aria-live="polite">
          Loading program scopes...
        </p>

        <p class="empty-state" *ngIf="programScopeKeysLoaded() && !hasProgramScopeKeyOptions()" role="status">
          No program scopes are configured for intake. Upload is disabled until at least one option is available.
        </p>

        <div class="upload-panel" *ngIf="programScopeKeysLoaded() && hasProgramScopeKeyOptions()">
          <label class="field">
            <span class="field-label">{{ programScopeKeyLabel() }}</span>
            <select
              class="field-input"
              [value]="programScopeKey()"
              [disabled]="isUploading()"
              (change)="onProgramScopeKeyChange($any($event.target).value)"
            >
              <option value="">Select a program scope...</option>
              <option *ngFor="let option of programScopeKeyOptions()" [value]="option.value">
                {{ option.viewValue }}
              </option>
            </select>
          </label>

          <label class="field">
            <span class="field-label">CSV file</span>
            <input
              class="field-input"
              type="file"
              accept=".csv,text/csv"
              [disabled]="isUploading()"
              (change)="onFileSelected($event)"
            />
            <span class="field-hint">
              Expected headers: incarceratedPersonDisplayName, incarceratedPersonIdentifier, programScopeKey.
            </span>
          </label>

          <div class="form-actions">
            <ez-button
              [buttonText]="isUploading() ? 'Uploading...' : 'Upload batch'"
              [disabled]="isUploading()"
              (click)="upload()"
            ></ez-button>
          </div>
        </div>

        <ng-container *ngIf="hasBatch() && batch() as currentBatch">
          <div class="batch-summary">
            <h3>Batch #{{ currentBatch.id }} - {{ currentBatch.sourceFileName }}</h3>
            <div class="counts">
              <span>Status: {{ currentBatch.batchStatusCode }}</span>
              <span>Total: {{ currentBatch.rowCount }}</span>
              <span class="count-valid">Valid: {{ currentBatch.validRowCount }}</span>
              <span class="count-invalid">Invalid: {{ currentBatch.invalidRowCount }}</span>
            </div>
            <div class="form-actions">
              <ez-button
                severity="secondary"
                [buttonText]="'Re-validate'"
                (click)="validate()"
              ></ez-button>
              <ez-button
                [buttonText]="isApplying() ? 'Applying...' : 'Apply batch'"
                [disabled]="isApplying() || !canApply()"
                (click)="apply()"
              ></ez-button>
            </div>
          </div>

          <ui-grid
            width="fill"
            containerClass="no-panel"
            data-testid="staging-grid"
            [singleClickEdit]="true"
            [rowData]="editableRows()"
            [columnDefs]="correctionColumnDefs()"
            [showPanelHeader]="false"
          ></ui-grid>
        </ng-container>

        <div class="apply-result" *ngIf="applyResult() as result">
          <h3>Apply result</h3>
          <div class="counts">
            <span class="count-valid">Applied: {{ result.appliedCount }}</span>
            <span class="count-invalid">Excluded: {{ result.excludedCount }}</span>
          </div>

          <div class="form-actions" *ngIf="hasExcludedRows()">
            <ez-button
              severity="secondary"
              [buttonText]="'Export excluded rows'"
              (click)="exportExcludedRows()"
            ></ez-button>
          </div>

          <ui-grid
            *ngIf="hasExcludedRows()"
            width="fill"
            containerClass="no-panel"
            data-testid="excluded-rows-grid"
            [rowData]="result.excludedRows"
            [columnDefs]="excludedRowColumnDefs()"
            [showPanelHeader]="false"
          ></ui-grid>
        </div>
      </ng-container>
    </div>
  </ez-block>
</ez-section>
